<template>
  <page-option overflow-hidden @click:reload="onReset()">
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E">mdi-clipboard-list-outline</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.tasks.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        placeholder="Tìm kiếm theo tên"
        disableCreate
      >
        <div class="d-flex flex-sm-row flex-column flex-warp">
          <div class="filter-item">
            <field-group
              v-model="params.status"
              background-color="#FFFFFF"
              dense
              :items="status.items"
              :label="$t('active-title.title')"
              :loading="status.loading"
              no-label
              outlined
              typeInput="v-select"
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.task_type_id"
              background-color="#FFFFFF"
              clearable
              dense
              item-text="title"
              item-value="id"
              :items="types.items"
              label="Loại"
              :loading="types.loading"
              no-label
              outlined
              typeInput="v-select"
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.date_start"
              background-color="#FFFFFF"
              clearable
              dense
              label="Ngày bắt đầu"
              no-label
              outlined
              type-input="field-date"
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.date_end"
              background-color="#FFFFFF"
              clearable
              dense
              label="Ngày bắt đầu"
              no-label
              outlined
              type-input="field-date"
            >
            </field-group>
          </div>
        </div>
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params.sync="params"
        :defaultParams="default_params"
        sync-params
      >
        <template v-slot:no-data>
          <p class="ma-0">Không có kết quả nào</p>
        </template>
        <template v-slot:[`item.user`]="{ item }">
          <div v-if="item.user">{{ item.user.name }}</div>
        </template>
        <template v-slot:[`item.start_at`]="{ item }">
          <span>
            {{ item.start_at | dateTime }}
          </span>
        </template>
        <template v-slot:[`item.end_at`]="{ item }">
          <span>
            {{ item.end_at | dateTime }}
          </span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span v-if="item.task_type.code == 'upload_image'">
            <v-icon left color="primary"
              >mdi-checkbox-multiple-marked-circle-outline</v-icon
            >
            <span style="color: #00725b">{{ item.task_type.title }}</span>
          </span>
          <span v-else-if="item.task_type.code == 'upload_vector'">
            <v-icon left color="blue">mdi-upload-network</v-icon>
            <span style="color: 'blue'">{{ item.task_type.title }}</span>
          </span>
          <span v-else>
            <span style="color: 'blue'">{{ item.task_type.title }}</span>
          </span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="STATUS_TYPE[item.status.toUpperCase()].color"
            outlined
            class="py-1 px-2 text-caption ma-2"
            label
          >
            {{ STATUS_TYPE[item.status.toUpperCase()].text }}
          </v-chip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div class="d-flex">
            <base-button-group
              class="full-width"
              :items="menus"
              :value="item"
              forceInList
            ></base-button-group>
          </div>
        </template>
      </base-serve-table>
    </v-sheet>
    <base-dialog
      v-model="dialog"
      max-width="500px"
      min-width="300px"
      scrollable
      title="Lỗi tiến trình"
      width="50%"
      :disabledAction="true"
    >
      <div class="red--text" style="font-size: 13px; padding-bottom: 40px">{{
        errorMessage
      }}</div>
      <!-- <v-textarea
        disabled
        dense
        auto-grow
        :value="errorMessage"
        class="red--text"
      ></v-textarea> -->
    </base-dialog>
    <!-- <TaskLogDialog ref="TaskLogDialog" @reset="onReset()" /> -->
  </page-option>
</template>

<script>
import { API_TASK } from '@api'
import FilterSearch from '@layouts/filter-search.vue'
import sdk from '@src/service/auth-sdk'
import { STATUS_TYPE } from '@constant'
import { ConfirmBuilder } from '@utils'

// import TaskLogDialog from './task-log-dialog.vue'
export default {
  mixins: [],
  components: {
    FilterSearch,
    // TaskLogDialog,
  },
  props: { option: { type: Object, default: () => ({ params: {} }) } },
  data: (vm) => ({
    default_params: {},
    params: { search: '', status: null, task_type_id: null },
    errorMessage: '',
    menus: [
      {
        title: 'Kiểm tra',
        icon: 'mdi-eye',
        handler: (item) => {
          return vm.onOpenErrorDialog(item)
        },
        disabled: (item) => item.status != STATUS_TYPE.FAILED.value,
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) =>
          item.status == STATUS_TYPE.CREATED.value ||
          item.status == STATUS_TYPE.PROCESSING.value,
      },
      //   {
      //     type: 'detail',
      //     handler: (item) => vm.onShowDetail(item),
      //     show: (item) =>
      //       item.status != STATUS_TYPE.CREATED && vm.authUser.isSysAdmin(),
      //   },
    ],
    headers: [
      {
        text: 'Tên',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Người tạo',
        align: 'start',
        sortable: false,
        value: 'user',
      },
      {
        text: 'Thời gian bắt đầu',
        align: 'start',
        sortable: true,
        value: 'start_at',
      },
      {
        text: 'Thời gian kết thúc',
        align: 'start',
        sortable: true,
        value: 'end_at',
      },
      {
        text: 'Loại',
        align: 'start',
        sortable: false,
        value: 'type',
      },
      {
        text: 'Trạng thái',
        align: 'start',
        sortable: false,
        value: 'status',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'start',
      },
    ],
    dialog: false,
    loading: false,
    status: {
      loading: false,
      items: [
        { text: 'Toàn bộ', value: null },
        { text: 'Đã được tạo', value: 'created' },
        { text: 'Đang tiến hành', value: 'pending' },
        { text: 'Hoàn thành', value: 'completed' },
        { text: 'Thất bại', value: 'failed' },
        { text: 'Huỷ bỏ', value: 'cancel' },
      ],
    },
    types: {
      loading: false,
      items: [],
    },
    users: {
      loading: false,
      items: [],
    },
  }),
  watch: {},
  computed: {
    STATUS_TYPE() {
      return STATUS_TYPE
    },
    api() {
      return API_TASK
    },
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    async fetchData() {
      this.types.loading = true
      try {
        const res = await sdk.request({
          url: 'task-types',
        })
        this.types.items = res.data
      } finally {
        this.types.loading = false
      }
      // this.users.loading = true
      // try {
      //   const res = await sdk.request({
      //     url: 'users',
      //   })
      //   this.users.items = res.data
      // } finally {
      //   this.users.loading = false
      // }
    },
    onReset() {
      this.$refs.table.reload()
    },
    onOpenErrorDialog(item) {
      this.dialog = true
      this.errorMessage = item.error
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onShowDetail(item) {
      this.$refs.TaskLogDialog.open(item)
    },
  },
}
</script>

<style scoped></style>
